/*
 * Class used for managing cookies
 */

// helper function to get cookie
function getCookie(index, defValue) {
    let value = $.cookie(index);
    if (!value || $.isEmptyObject(value)) {
        value = defValue;
    } else {
        value = JSON.parse(value);
    }

    return value;
}

export default class CookieHelper {
    constructor() {
        // recent product views values
        this.INDEX_PAGE_VIEWS = 'recent_product_views';
        this.PAGE_VIEW_EXPIRE = 30; // 30 days
        this.PAGE_VIEW_CUTOFF_TIME = new Date().getTime() - this.PAGE_VIEW_EXPIRE * 24 * 60 * 60 * 1000; // in ms
    }

    // add a product view
    //  responsible for preventing dupes & removing aged out items
    //  $id - product id
    addProductView(id) {
        let recentViews = getCookie(this.INDEX_PAGE_VIEWS, []);

        // remove previous view
        //   and remove expired items
        recentViews = recentViews.filter((item) => item.id !== id && item.time > this.PAGE_VIEW_CUTOFF_TIME);

        // add new view
        recentViews.push({
            id,
            time: new Date().getTime(),
        });
        $.cookie('recent_product_views', JSON.stringify(recentViews), { expires: this.PAGE_VIEW_EXPIRE, path: '/' });
    }

    // gets time value for last product view
    //    0 if not found
    getProductView(id) {
        const recentViews = getCookie(this.INDEX_PAGE_VIEWS, []);
        const view = recentViews.find((item) => item.id === id);

        // check view time within window
        if (view && view.time > this.PAGE_VIEW_CUTOFF_TIME) {
            return view.time;
        }

        return 0;
    }
}
